import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { TokenManager } from '../Globals';

@Component({
  selector: 'app-continuesession',
  templateUrl: './continuesession.component.html',
  styleUrls: ['./continuesession.component.css']
})
export class ContinuesessionComponent implements OnInit {

  constructor(private loginService:LoginService, private route:ActivatedRoute, private globals:Globals, private router:Router, private tokenManager:TokenManager) { }

  ngOnInit() {
    
  }


  Login(username:string, password:string){
    var sessionId = this.route.snapshot.paramMap.get("sessionKey");

    this.loginService.continueSession(username, password, sessionId).subscribe(result=>{
        this.globals.Session = result;
        this.globals.CardItems = [];
        this.router.navigate(['/', 'home']);
        this.loginService.setSession(result);
        if (this.globals.Session.Session.SessionId != null) {
          this.tokenManager.store('BRNSessionKey', this.globals.Session.Session.SessionId);
        }
    });
  }
}
